<div class="modal-content border-0 rounded-0">
    <div class="modal-header mm-modal-header rounded-0 d-flex flex-row align-items-center justify-content-between">
        <h6 class="modal-title" id="titleLabel">Create  {{ enterpriseLabels.universalIdLabel }}</h6>
        <button type="button" class="btn-close btn-close-white" aria-label="Close" data-identifier="close-create-universal-id-modal-btn" (click)="closeModal()">
        </button>
    </div>
    <div class="modal-body">
	    <div class="card">
		    <div class="card-header mm-card-header">
                {{ enterpriseLabels.universalIdLabel }} Account Details
		    </div>
			    <div class="card-body">
                    <lib-universal-id-form [enterpriseId]="currentEnterpriseId"
                                           [enterpriseLabels]="enterpriseLabels"
                                           [userLinkObs]="userLinksEvent"
                                           (formValidation)="universalIdCreationValidation($event)"
                                           [saveUniversalIdObs]="createUniversalIdEvent"
                                           (submitted)="onSubmit()"/>
			    </div>
        </div>
	    <br>
        <mmoga-link-ema-accounts [currentEnterpriseId]="currentEnterpriseId" (linkEmaAccountsFormUpdated)="linkEmaAccountsFormUpdated($event)"></mmoga-link-ema-accounts>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-default" data-identifier="cancel-create-universal-id-modal-btn"
                (click)="cancel()">Cancel</button>
        <button type="submit" class="btn btn-sm btn-primary" data-identifier="create-universal-id-modal-btn"
                [disabled]="!universalIdDetailsValid || !linkEmaAccountsValid"
                (click)="create()">Create</button>
    </div>
</div>
